import { Verified } from 'lucide-react'
import { MobileDealsPage } from 'pages/app/deals/mobile'
import { MobileContactsPage } from 'pages/app/contacts/mobile'
import Home from 'pages/app/mobile/home'
import SearchPage from 'pages/app/mobile/search'
import { MobileAppLayout } from 'pages/app/mobile/layout'
import MobileNotFound from 'pages/app/mobile/mobile-not-found'
import Failed from 'pages/auth/failed'
import { MobileAuthLayout } from 'pages/auth/layout/mobile'
import Login from 'pages/auth/login'
import Register from 'pages/auth/register'
import ResetPassword from 'pages/auth/reset-password'
import ResetPasswordConfirm from 'pages/auth/reset-password-confirm'
import SSOCallback from 'pages/auth/sso-callback'
import SSOLogin from 'pages/auth/sso-login'
import { MobileCommonLayout } from 'pages/common/layout/mobile'
import Privacy from 'pages/common/privacy'
import Terms from 'pages/common/terms'
import Oops from 'pages/oops'
import { RouterProvider } from 'react-router-dom'
import { sentryCreateBrowserRouter } from 'services/sentry'
import { PageWithTitle } from 'utils/PageWithTitle'
import ProtectedRoute from 'utils/ProtectedRoute'
import { MobileDealsCreate } from 'pages/app/deals/MobileDealsCreate'
import MobileContactsCreate from 'pages/app/contacts/mobile/MobileContactsCreate'
import MobileCompanyCreate from 'pages/app/companies/mobile/MobileCompanyCreate'
import { MobileSamplesPage } from 'pages/app/samples/mobile'
import { MobileSampleDetailPage } from 'pages/app/samples/MobileSampleDetailPage'
import { MobileCreateSamplePage } from 'pages/app/samples/MobileCreateSamplePage'
import { MobileRemindersPage } from 'pages/app/reminders/mobile'
import { MobileCreateReminderPage } from 'pages/app/reminders/MobileCreateReminderPage'
import { MobileNotesPage } from 'pages/app/notes/mobile'
import { MobileEditNotePage } from 'pages/app/notes/MobileEditNotePage'
import { MobileDeleteNotePage } from 'pages/app/notes/MobileDeleteNodePage'
import { MobileChainPage } from 'pages/app/new-company-pages/MobileChainPage'
import { MobileDoorsListPage } from 'pages/app/new-company-pages/MobileDoorsListPage'
import { MobileDoorPage } from 'pages/app/new-company-pages/MobileDoorPage'
import { MobileAccountAttributesPage } from 'components/MobileCompanyPage/MobileAccountAttributes'
import { MobileEventsPage } from 'pages/app/events/mobile'
import { MobileMenuPage } from 'pages/app/menu/mobile'
import { MobileEditReminderPage } from 'pages/app/reminders/MobileEditReminderPage'

export default function Mobile() {
  const appRouter = sentryCreateBrowserRouter(
    [
      {
        path: '*',
        element: (
          <ProtectedRoute>
            <MobileNotFound />
          </ProtectedRoute>
        ),
      },
      {
        path: '/',
        element: <MobileAppLayout />,
        errorElement: <Oops />,
        children: [
          {
            path: '',
            element: (
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            ),
          },
          {
            path: 'chain/:chain_name',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Dashboard">
                  <MobileChainPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'chain/:chain_name/account-attributes',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Account Attributes">
                  <MobileAccountAttributesPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'chain/:chain_name/doors',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Doors">
                  <MobileDoorsListPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'door/:door_id',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Door">
                  <MobileDoorPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'restaurant/:door_id',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Restaurant">
                  <MobileDoorPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'deals',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Deals">
                  <MobileDealsPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'deals/create',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Deals">
                  <MobileDealsCreate />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'contacts',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Contacts">
                  <MobileContactsPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'contacts/create',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Contacts">
                  <MobileContactsCreate />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'companies/create',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Create Company">
                  <MobileCompanyCreate />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'samples',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Samples">
                  <MobileSamplesPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'samples/:sample_id',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Sample Details">
                  <MobileSampleDetailPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'samples/create',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Create a Sample">
                  <MobileCreateSamplePage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'reminders',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Reminders">
                  <MobileRemindersPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'reminders/create',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Create a Reminder">
                  <MobileCreateReminderPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'reminders/:reminder_id/edit',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Edit Reminder">
                  <MobileEditReminderPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'notes',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Notes">
                  <MobileNotesPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'notes/:note_id/edit',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Edit Note">
                  <MobileEditNotePage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'notes/:note_id/delete',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Delete Note">
                  <MobileDeleteNotePage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'events',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Events">
                  <MobileEventsPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'menu',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Menu">
                  <MobileMenuPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
          {
            path: 'search',
            element: (
              <ProtectedRoute>
                <PageWithTitle title="Search">
                  <SearchPage />
                </PageWithTitle>
              </ProtectedRoute>
            ),
          },
        ],
      },

      {
        path: '/login',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Log-in">
                <Login />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/signup',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Sign-up">
                <Register />
              </PageWithTitle>
            ),
          },
        ],
      },

      {
        path: '/sso-login',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="SSO Login">
                <SSOLogin />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/auth/sso-callback',
        element: (
          <PageWithTitle title="SSO Authentication">
            <SSOCallback />
          </PageWithTitle>
        ),
      },
      {
        path: '/email-verified-confirmation',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Email Verified">
                <Verified />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/email-verification-failed',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Email Verification Failed">
                <Failed />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/reset-password',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Reset Password">
                <ResetPassword />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/password-reset-confirm/:uid/:token',
        element: <MobileAuthLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Reset Password Confirmation">
                <ResetPasswordConfirm />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/terms-of-use',
        element: <MobileCommonLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Terms of Use">
                <Terms />
              </PageWithTitle>
            ),
          },
        ],
      },
      {
        path: '/privacy-policy',
        element: <MobileCommonLayout />,
        children: [
          {
            path: '',
            element: (
              <PageWithTitle title="Privacy Policy">
                <Privacy />
              </PageWithTitle>
            ),
          },
        ],
      },
    ],
    { basename: import.meta.env.BASE_URL }
  )

  return <RouterProvider router={appRouter} />
}
